import { getAuth } from 'firebase/auth';
import React, { useState } from 'react';
import config from '../config';
import './LocationSelector.css'; // Import the CSS file

interface LocationSelectorProps {
    onLocationSelect: (location: string) => void;
}

const LocationSelector: React.FC<LocationSelectorProps> = ({ onLocationSelect }) => {
    const [input, setInput] = useState('');
    const [locations, setLocations] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInput(event.target.value);
    };

    const handleSearch = async () => {
        setLoading(true);
        setError(null);

        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            const token = await user.getIdToken(true);
            console.log("User: ", user);  // Log the user
            console.log("Token: ", token);  // Log the token

            try {
                // Make a request to the Google Places API with the user's input
                const response = await fetch(`${config.apiUrl}/api/places?input=${input}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                console.log("Response:", response);  // Log the response
                if (!response.ok) {
                    throw new Error('Failed to fetch locations');
                }

                const data = await response.json();
                console.log("Response data:", data);
                const newLocations = data;
                setLocations(newLocations);
            } catch (error) {
                if (error instanceof Error) {
                    console.error(error.message);
                    setError(error.message);
                } else {
                    console.error('An unexpected error occurred');
                    setError('An unexpected error occurred');
                }
            } finally {
                setLoading(false);
            }
        }
    };

    const handleLocationSelect = (location: string) => {
        onLocationSelect(location);
        setInput(location); // Update the input value with the selected location
        setLocations([]); // Clear the locations array
    };

    return (
        <div className="locationSelector">
            <h3>Search Places (or Gyms) to meet:</h3>
            <p>Enter a location to search for places to meet. Your selection will automatically be filled in the message to be sent.</p>
            <input type="text" value={input} onChange={handleInputChange} />
            <button onClick={handleSearch}>Search</button>
            {loading && <p>Loading...</p>}
            {error && <p>Error: {error}</p>}
            {locations.map((location, index) => (
                <button key={index} onClick={() => handleLocationSelect(location)}>{location}</button>
            ))}
        </div>
    );
};

/*If we want to do drop down instead, replace as so:
<div className="locationSelector">
    <h3>Search Places (or Gyms) to meet:</h3>
    <p>Enter a location to search for places to meet. Your selection will automatically be filled in the message to be sent.</p>
    <input type="text" value={input} onChange={handleInputChange} />
    <button onClick={handleSearch}>Search</button>
    {loading && <p>Loading...</p>}
    {error && <p>Error: {error}</p>}
    {locations.length > 0 && (
        <select onChange={(e) => handleLocationSelect(e.target.value)}>
            <option value="">Select a location</option>
            {locations.map((location, index) => (
                <option key={index} value={location}>{location}</option>
            ))}
        </select>
    )}
</div>
*/



export default LocationSelector;
